<template>
  <button>
    <slot>Please Enter Button Label</slot>
  </button>
</template>

<style scoped>
button {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  height: 45px;
  padding: 0 15px;
  background-color: #ffb054;
  border-radius: 8px;
  font-weight: 600;
  font-size: 14px;
  line-height: 14px;
  color: #202223;
  border: none;
  outline: none;
  pointer-events: all;
}

button:hover,
button:active {
  background-color: #e3973d;
}

button:disabled {
  cursor: wait;
  background-color: #acacac;
}

.small {
  height: 40px;
}

.flat {
  background-color: #fff;
  border: 1px solid #cecece;
}

button.flat:hover,
button.flat:focus {
  background-color: #f6f6f6;
}

.red-text {
  color: #c83e25;
}

.search-btn {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  width: 50px;
}
</style>
